import { HttpClient } from '@/shared/lib/http-client';

export const changePassword = async({ token, email, password, passwordConfirmation }) => {
  const response = await HttpClient.post('/auth/password/reset', {
    token,
    email,
    password,
    password_confirmation: passwordConfirmation,
  });

  return response.data?.data;
};
